import React from 'react';
import { motion } from 'framer-motion';
import { Building, Package2, CreditCard, Share2, AlertCircle, TrendingUp } from 'lucide-react';
import './Features.css';
import GradualSpacingText from './GradualSpacingText/GradualSpacingText';

const Features = () => {
  const allFeatures = [
    {
      title: 'Dry-Van Truckload (FTL)',
      description: 'Nationwide truckload capacity for general freight, retail products, and industrial goods.',
      icon: <Building size={28} />
    },
    {
      title: 'Dedicated & Contract Freight',
      description: 'Consistent lane coverage, guaranteed capacity, and scalable fleet support for long-term partnerships.',
      icon: <TrendingUp size={28} />
    },
    {
      title: 'Spot & Regional Freight',
      description: 'Fast, flexible spot and regional coverage for immediate or short-notice needs.',
      icon: <Package2 size={28} />
    },
    {
      title: 'Nationwide Coverage',
      description: 'Coverage across all U.S. regions including port, DC, and long-haul lanes.',
      icon: <Share2 size={28} />
    },
    {
      title: 'Drop & Hook / Live Loads',
      description: 'Support for high-volume distribution, manufacturing, and port operations.',
      icon: <AlertCircle size={28} />
    },
    {
      title: 'Safety & Compliance',
      description: 'FMCSA compliant operations with ELD tracking, insurance, and driver performance monitoring.',
      icon: <CreditCard size={28} />
    }
  ];

  return (
    <section 
      id="features-section" 
      className="features-new-section reveal"
      style={{ 
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/demo.png)`,
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="features-container">
        <header className="features-header">
          <span className="features-badge">Our Expertise</span>
          <h2 className="features-main-title">Professional Freight Solutions</h2>
        </header>

        <div className="features-grid-new">
          {allFeatures.map((feature, index) => (
            <div
              key={index}
              className="feature-item-new"
            >
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <div className="feature-text">
                <h3 className="feature-title-new">
                  {feature.title}
                </h3>
                <p className="feature-description-new">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;